import type {PageRouteConfig} from '@router';

import VendorScore from 'modules/VendorScore/VendorScore';

export function createVendorScoreRoute(): PageRouteConfig {
  return {
    element: <VendorScore />,
    layout: {
      title: 'امتیاز عملکرد',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
